<template>
    <div class="fluid">
        <h1 class="app-title">Cadastro de Devedor</h1>
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col class="text-right">
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>
            <TabelaDevedor
                    :resultado="items"
                    :fields="fields"
                    :configTable="configTable"
                    :selecteds="selecteds"
                    :filtro="filtros"
                    @openFilterPopup="openFilterPopup"
                    @consultar="consultar"/>
            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados">
                        <span>Devedores Encontrados</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : items.length}}</span>
                    </div>

                    <div class="registros-encontrados" style="margin-left: 15px">
                        <span>Devedores Selecionados</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{selecteds.length}}</span>
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col md="3"></b-col>
                <b-col md="6">
                    <div class="d-flex justify-content-between align-items-center">
                        <div style="margin: auto">
                            <b-button class="ml-2" variant="primary" @click="incluir">
                                <i class="fa fa-plus"></i> Incluir
                            </b-button>
                            <b-button class="ml-2" variant="secondary" @click="alterar" :disabled="selecteds.length !== 1">
                                <i class="fas fa-edit"></i> Editar
                            </b-button>
                        </div>
                    </div>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-card>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import TabelaDevedor from "./TabelaDevedor";
    import CompBotaoExibirOcultarColuna from "../shared/components/CompBotaoExibirOcultarColuna";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import CompLoading from "../shared/components/CompLoading";

    export default {
        components: {CompLoading, CompFiltroGrid, CompBotaoExibirOcultarColuna, TabelaDevedor, Multiselect},
        data() {
            return {
                ll: true,
                l2: true,
                urlApi: null,
                token: null,
                value: null,
                indice: null,
                fields: [
                    {
                        key: "selecionar",
                    }
                ],
                items: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'contribuinte.nome',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                showColunms: [],
                selecteds: [],
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    mascara: null,
                    campoTexto: null,
                    campoMascara: null,
                    campoData: null,
                    campoRadio: null,
                    listaValores: []
                },
                filtros: {
                    filtrarNome: null,
                    nome: null,
                    tipoContribuinte: null,
                    filtrarCpf: null,
                    cpf: null,
                    filtrarCnpj: null,
                    cnpj: null,
                    filtrarEmail: null,
                    email: null,
                    filtrarTelefone: null,
                    telefone: null,
                    filtrarAtualizacao: null,
                    atualizacao: null,
                    situacao: null
                }
            }
        },
        methods: {
            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/contribuinte/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            prevPage() {
                this.configTable.currentPage = this.configTable.currentPage - 1;
                this.consultar();
            },

            nextPage() {
                this.configTable.currentPage = this.configTable.currentPage + 1;
                this.consultar();
            },

            async obterColunasUsuario() {
                const funcionalidade = 'devedor';

                this.configTable.load = true;
                axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i + 1)
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            toggleColuna(i) {
                let ativo;
                if (this.showColunms.includes(i)) {
                    this.showColunms.splice(this.showColunms.indexOf(i), 1);
                    this.fields[i].thClass = 'd-none';
                    this.fields[i].tdClass = 'd-none';
                    ativo = false
                } else {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                    ativo = true
                }

                this.atualizarConfiguracaoColunm(i, ativo)
            },

            async atualizarConfiguracaoColunm(i, ativo) {
                const json = {
                    codFuncionalidade: this.fields[i].codFuncionalidade,
                    codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                    ativo,
                };
                axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            incluir(evt) {
                evt.preventDefault();
                this.$router.push({path: '/devedor/incluir'});
            },

            alterar(evt) {
                evt.preventDefault();
                if (this.selecteds[0]) {
                    this.$store.commit('setDevedor', this.selecteds[0]);
                    this.$router.push({path: '/devedor/editar'});
                }
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;
                    if(this.filtro.campoFiltro == 'Nome') {
                        this.filtro.filtrarEm = this.filtros.filtrarNome;
                        this.filtro.campoTexto = this.filtros.nome;
                    } else if(this.filtro.campoFiltro == 'Tipo de Devedor') {
                        this.filtro.campoRadio = this.filtros.tipoContribuinte;
                    } else if(this.filtro.campoFiltro == 'CPF') {
                        this.filtro.filtrarEm = this.filtros.filtrarCpf;
                        this.filtro.campoMascara = this.filtros.cpf;
                    } else if(this.filtro.campoFiltro == 'CNPJ') {
                        this.filtro.filtrarEm = this.filtros.filtrarCnpj;
                        this.filtro.campoMascara = this.filtros.cnpj;
                    } else if(this.filtro.campoFiltro == 'E-mail') {
                        this.filtro.filtrarEm = this.filtros.filtrarEmail;
                        this.filtro.campoTexto = this.filtros.email;
                    } else if(this.filtro.campoFiltro == 'Telefone') {
                        this.filtro.filtrarEm = this.filtros.filtrarTelefone;
                        this.filtro.campoMascara = this.filtros.telefone;
                    } else if(this.filtro.campoFiltro == 'Data Última Atualização') {
                        this.filtro.filtrarEm = this.filtros.filtrarAtualizacao;
                        this.filtro.campoData = this.filtros.atualizacao;
                    } else if(this.filtro.campoFiltro == 'Situação') {
                        this.filtro.campoRadio = this.filtros.situacao;
                    }

                    if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoMascara = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                }

                if(this.filtro.campoFiltro == 'Nome') {
                    this.filtros.filtrarNome = this.filtro.filtrarEm;
                    this.filtros.nome = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Tipo de Devedor') {
                    this.filtros.tipoContribuinte = this.filtro.campoRadio;
                } else if(this.filtro.campoFiltro == 'CPF') {
                    this.filtros.filtrarCpf = this.filtro.filtrarEm;
                    this.filtros.cpf = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'CNPJ') {
                    this.filtros.filtrarCnpj = this.filtro.filtrarEm;
                    this.filtros.cnpj = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'E-mail') {
                    this.filtros.filtrarEmail = this.filtro.filtrarEm;
                    this.filtros.email = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Telefone') {
                    this.filtros.filtrarTelefone = this.filtro.filtrarEm;
                    this.filtros.telefone = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Data Última Atualização') {
                    this.filtros.filtrarAtualizacao = this.filtro.filtrarEm;
                    this.filtros.atualizacao = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.filtros.situacao = this.filtro.campoRadio;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Nome') {
                    this.configTable.sortField = 'contribuinte.nome';
                } else if(this.filtro.campoFiltro == 'Tipo de Devedor') {
                    this.configTable.sortField = 'contribuinte.tipoDevedor';
                } else if(this.filtro.campoFiltro == 'CPF') {
                    this.configTable.sortField = 'contribuinte.numeroCpf';
                } else if(this.filtro.campoFiltro == 'CNPJ') {
                    this.configTable.sortField = 'contribuinte.numeroCnpj';
                } else if(this.filtro.campoFiltro == 'E-mail') {
                    this.configTable.sortField = 'contribuinte.email';
                } else if(this.filtro.campoFiltro == 'Telefone') {
                    this.configTable.sortField = 'contribuinte.telefone';
                } else if(this.filtro.campoFiltro == 'Data Última Atualização') {
                    this.configTable.sortField = 'contribuinte.dataHoraAlteracao';
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.configTable.sortField = 'contribuinte.indAtivo';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },
            limparFiltros() {
                this.filtro.filtrarEm = null;
                this.filtro.campoTexto = null;
                this.filtro.campoMascara = null;
                this.filtro.campoData = null;
                this.filtro.campoRadio = null;
                this.filtros =  {
                    filtrarNome: null,
                    nome: null,
                    tipoContribuinte: null,
                    filtrarCpf: null,
                    cpf: null,
                    filtrarCnpj: null,
                    cnpj: null,
                    filtrarEmail: null,
                    email: null,
                    filtrarTelefone: null,
                    telefone: null,
                    filtrarAtualizacao: null,
                    atualizacao: null,
                    situacao: null
                };

                this.consultar();
            }
        },
        watch: {
            perPage() {
                this.configTable.currentPage = 1;
                this.consultar();
            }
        },
        computed: {
            perPage() {
                return this.configTable.perPage;
            },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.$store.commit("setMessages", {});

            const msgDevedor = this.$store.getters.getMsgCrud;
            if(msgDevedor) {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: msgDevedor}]});
                this.$store.commit("setMsgCrud", null)
            }

            this.obterColunasUsuario();
            this.consultar();
        }
    }
</script>
